const styles = (theme: Object) => ({
  root: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    padding: '5px 0',
    backgroundColor: '#000',
    color: '#fff',
    fontSize: 10,
    fontWeight: 500,
    textAlign: 'center',
    zIndex: theme.zIndex.footer,
  },
  close: {
    float: 'right',
    paddingRight: '20px',
  },
  hide: {
    display: 'none',
  },
});

export default styles;
